import { Settings as SettingsIcon } from '@mui/icons-material';
import { Box, Checkbox, FormControlLabel, IconButton, MenuItem, Popover, Typography } from '@mui/material';
import React, { useState } from 'react';
import { ColumnSelectorOption } from './ITable';
import { Loading } from '../loading/Loading';
import usePermissionAllowed from '../../hooks/usePermissionAllowed';
import { Actions } from '../../services/react-query/permissions';

interface ColumnSelectorProps {
  availableColumns: ColumnSelectorOption[];
  selectedKeys: string[];
  isDownloadingCsv?: boolean;
  onChange: (keys: string[]) => void;
  onDownloadCsv?: () => void;
}

export default function ColumnSelector({ availableColumns, selectedKeys, isDownloadingCsv, onChange, onDownloadCsv }: ColumnSelectorProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [columnsAnchorEl, setColumnsAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleColumnsOpen = () => {
    setColumnsAnchorEl(anchorEl);
    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleColumnsClose = () => {
    setColumnsAnchorEl(null);
  };

  const handleDownloadClick = () => {
    onDownloadCsv!();
  };

  const open = Boolean(anchorEl);
  const openColumns = Boolean(columnsAnchorEl);

  return (
    <>
      <IconButton onClick={handleOpen} sx={{ padding: 0 }}>
        <SettingsIcon />
      </IconButton>
      <Popover open={open} anchorEl={anchorEl} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}>
        <Box p={1}>
          <MenuItem onClick={() => handleColumnsOpen()}>Set Columns</MenuItem>
          <MenuItem sx={{ gap: 1 }} disabled={!(onDownloadCsv && usePermissionAllowed(Actions.REPORT_READ))} onClick={() => handleDownloadClick()}>
            {isDownloadingCsv ? (
              <>
                <>Downloading...</>
                <Loading size={12} />
              </>
            ) : (
              'Download CSV'
            )}
          </MenuItem>
        </Box>
      </Popover>
      <Popover open={openColumns} anchorEl={columnsAnchorEl} onClose={handleColumnsClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}>
        <Box p={2} sx={{ display: 'flex', flexDirection: 'column' }}>
          <Typography variant="h6">Columns</Typography>
          {availableColumns.map((column) => (
            <FormControlLabel
              key={column.key}
              control={
                <Checkbox
                  checked={selectedKeys.includes(column.key)}
                  onChange={(e) => {
                    const newKeys = e.target.checked ? [...selectedKeys, column.key] : selectedKeys.filter((key) => key !== column.key);
                    onChange(newKeys);
                  }}
                />
              }
              label={column.label}
            />
          ))}
        </Box>
      </Popover>
    </>
  );
}
